import { useMemo } from "react";
import { useWindowDimensions } from "react-native";

export const useScreenSize = () => {
  const { width: screenWidth } = useWindowDimensions();

  return useMemo(() => {
    let breakpoint = "xs";
    if (screenWidth >= 1536) breakpoint = "2xl";
    else if (screenWidth >= 1280) breakpoint = "xl";
    else if (screenWidth >= 1024) breakpoint = "lg";
    else if (screenWidth >= 768) breakpoint = "md";
    else if (screenWidth >= 640) breakpoint = "sm";

    return {
      breakpoint,
      isMobile: screenWidth < 1024,
      screenSize: screenWidth,
    };
  }, [screenWidth]);
};
